
<template>
  <section class="content">
   <div class="box box-info" >
    <div class="p-toolbar p-component mb-4">
        <itemMasterdialog ref="itemdialog"/>
      </div>
        <itemMasterList @delete-message="deleteMessage" @edit-item="editItemMaster" @view-item="viewItemMaster"/>
    </div>
  </section>
</template>
<script>
import itemMasterList from './itemMasterList.vue'
import itemMasterdialog from '../itemDialog/itemMasterDialog.vue'

export default {
  name: 'itemMaster',
  props: ['item'],
  data() {
    return {
    }
  },
  methods: {
    editItemMaster(data) {
      this.$refs.itemdialog.editIemMaster(data)
    },
    viewItemMaster(data) {
      this.$refs.itemdialog.openViewItem(data)
    },
    deleteMessage(value) {
      this.$toast.add({severity: value.messageType, summary: '', detail: value.message, life: 10000})
    }
  },
  components: {
    itemMasterList,
    itemMasterdialog
  }
}
</script>
<style scoped src="@../../../static/css/dialogEntry.css">
img.preview {
  max-width:250px;
  max-height:250px;
}
</style>



// WEBPACK FOOTER //
// ItemMaster.vue?7e0d6562